import { IconDashboard, IconBuilding, IconUserPlus, IconUsers, IconRobot, IconBooks, IconServer } from '@tabler/icons';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [
        {
            id: 'main',
            title: '',
            type: 'group',
            children: [
                {
                    id: 'dashboard',
                    title: 'Dashboard',
                    type: 'item',
                    url: '/dashboard',
                    icon: IconDashboard,
                    breadcrumbs: false,
                    roles: ['SUPER_ADMIN', 'CLIENT_ADMIN', 'USER']
                },
                {
                    id: 'company-registration',
                    title: 'Company Registration',
                    type: 'item',
                    url: '/company-registration',
                    icon: IconBuilding,
                    breadcrumbs: true,
                    roles: ['SUPER_ADMIN']
                },
                {
                    id: 'register-client-admin',
                    title: 'Client Admin User',
                    type: 'item',
                    url: '/register-client-admin',
                    icon: IconUserPlus,
                    breadcrumbs: true,
                    roles: ['SUPER_ADMIN']
                },
                {
                    id: 'end-users',
                    title: 'Users',
                    type: 'item',
                    url: '/end-users',
                    icon: IconUsers,
                    breadcrumbs: true,
                    roles: ['CLIENT_ADMIN']
                },
                {
                    id: 'knowledge-warehouse',
                    title: 'Knowledge Warehouse',
                    type: 'item',
                    url: '/knowledge-warehouse',
                    icon: IconBooks,
                    breadcrumbs: true,
                    roles: ['SUPER_ADMIN', 'CLIENT_ADMIN']
                },
                {
                    id: 'bot-configuration',
                    title: 'Bot',
                    type: 'item',
                    url: '/bot-configuration',
                    icon: IconRobot,
                    breadcrumbs: true,
                    roles: ['SUPER_ADMIN', 'CLIENT_ADMIN', 'USER']
                },
                {
                    id: 'faq',
                    title: 'FAQ',
                    type: 'item',
                    url: '/faq',
                    icon: IconServer,
                    breadcrumbs: true,
                    roles: ['SUPER_ADMIN', 'CLIENT_ADMIN']
                }
            ]
        }
    ]
};

export default menuItems;
